import { create } from "zustand";

export type IamDashTab = "people" | "roles" | "orgs" | "invites";

interface IamDashboardState {
  activeTab: IamDashTab;
  setActiveTab: (tab: IamDashTab) => void;
}

export const useIamDashboardStore = create<IamDashboardState>((set) => ({
  activeTab: "people",
  setActiveTab: (tab) => set({ activeTab: tab }),
}));
